import { Address } from "./Address";

export class ProductImporter {

  constructor(
    public importerName?: string,
    public importerAddress?: Address,
    public importerCountryCode?: string,
    public importerWebsite?: string,
  ) {
    this.importerAddress = new Address();
  }
}
